import React from "react";

const ArrowsIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M17.7071 12.2929C17.3166 11.9024 16.6834 11.9024 16.2929 12.2929C15.9024 12.6834 15.9024 13.3166 16.2929 13.7071L18.5858 16L5 16C4.44772 16 4 16.4477 4 17C4 17.5523 4.44772 18 5 18L18.5858 18L16.2929 20.2929C15.9024 20.6834 15.9024 21.3166 16.2929 21.7071C16.6834 22.0976 17.3166 22.0976 17.7071 21.7071L21.7071 17.7071C22.0976 17.3166 22.0976 16.6834 21.7071 16.2929L17.7071 12.2929Z"
        fill="#10B981"
      />
      <path
        d="M19 8C19.5523 8 20 7.55228 20 7C20 6.44772 19.5523 6 19 6L5.41421 6L7.70711 3.70711C8.09763 3.31658 8.09763 2.68342 7.70711 2.29289C7.31658 1.90237 6.68342 1.90237 6.29289 2.29289L2.29289 6.29289C1.90237 6.68342 1.90237 7.31658 2.29289 7.70711L6.29289 11.7071C6.68342 12.0976 7.31658 12.0976 7.70711 11.7071C8.09763 11.3166 8.09763 10.6834 7.70711 10.2929L5.41421 8L19 8Z"
        fill="#646F87"
      />
    </svg>
  );
};

export default ArrowsIcon;
